import { FetchTransport, type FetchTransportOptions } from 'ProdantixSdk/core/transport';
import type { Transport, TransportRequest } from 'ProdantixSdk/core/types';

interface BeaconNavigator {
  sendBeacon?(url: string, data?: Blob): boolean;
}

function isPageHidden(): boolean {
  const doc = (globalThis as { document?: { visibilityState?: string } }).document;
  return doc?.visibilityState === 'hidden';
}

function trySendBeacon(request: TransportRequest): boolean {
  const nav = (globalThis as { navigator?: BeaconNavigator }).navigator;
  const BlobCtor = (globalThis as { Blob?: typeof Blob }).Blob;
  if (!nav?.sendBeacon || !BlobCtor) {
    return false;
  }
  const payload = JSON.stringify({ ...request.body, api_key: request.projectKey });
  try {
    const blob = new BlobCtor([payload], { type: 'application/json' });
    return nav.sendBeacon(request.url, blob);
  } catch {
    return false;
  }
}

export class WebTransport implements Transport {
  private readonly fetchTransport: FetchTransport;

  constructor(options: FetchTransportOptions = {}) {
    this.fetchTransport = new FetchTransport(options);
  }

  async send(request: TransportRequest): Promise<void> {
    if (isPageHidden() && trySendBeacon(request)) {
      return;
    }
    await this.fetchTransport.send(request);
  }
}
